const themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
const themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
const themeToggleBtn = document.getElementById('theme-toggle');

function updateThemeToggleLabels(isDark) {
    const label = isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro';
    const tooltip = isDark ? 'Modo claro' : 'Modo oscuro';
    
    document.querySelectorAll('#theme-toggle, .theme-toggle').forEach(btn => {
        btn.setAttribute('aria-label', label);
        btn.setAttribute('title', tooltip);
    });
}

// Inicializar iconos y etiquetas según el tema activo
const isInitiallyDark = localStorage.getItem('color-theme') === 'dark' || 
    (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);

if (themeToggleDarkIcon && themeToggleLightIcon) {
    if (isInitiallyDark) {
        themeToggleLightIcon.classList.remove('hidden');
    } else {
        themeToggleDarkIcon.classList.remove('hidden');
    }
}
updateThemeToggleLabels(isInitiallyDark);

if (themeToggleBtn) {
    let event = new Event('dark-mode');

    themeToggleBtn.addEventListener('click', function() {
        // Toggle iconos
        if (themeToggleDarkIcon && themeToggleLightIcon) {
            themeToggleDarkIcon.classList.toggle('hidden');
            themeToggleLightIcon.classList.toggle('hidden');
        }

        let isNowDark = false;
        // if set via local storage previously
        if (localStorage.getItem('color-theme')) {
            if (localStorage.getItem('color-theme') === 'light') {
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
                isNowDark = true;
            } else {
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
                isNowDark = false;
            }
        // if NOT set via local storage previously
        } else {
            if (document.documentElement.classList.contains('dark')) {
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
                isNowDark = false;
            } else {
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
                isNowDark = true;
            }
        }

        updateThemeToggleLabels(isNowDark);
        document.dispatchEvent(event);

        // Vocalizar con Lector de Voz TTS si está activo
        if (typeof window.speakAccessibilityText === 'function') {
            window.speakAccessibilityText(isNowDark ? 'Modo oscuro activado' : 'Modo claro activado');
        }
    });
}
